import axios from '@/plugins/axios'

const endpoint = '/api-proxy/api/v1/observability'

export type CursorPage<T> = {
  items: T[]
  nextCursor?: string
}

export type Visit = {
  id: number
  userId: number
  routeName: string
  path: string
  replaySessionId?: number
  createdAt: string
}

export type ReplaySession = {
  id: number
  userId: number
  eventCount: number
  createdAt: string
}

export type CountByKey = {
  key: string
  count: number
}

export type VisitAnalytics = {
  from: string
  to: string
  pageCounts: CountByKey[]
  hourCounts: Array<{ hour: number; count: number }>
}

export type InteractionAnalytics = {
  from: string
  to: string
  totalVisits: number
  actions: Array<{
    eventName: string
    clickCount: number
    uniqueUsers: number
  }>
}

export type ErrorEvent = {
  id: number
  source: string
  severity: string
  fingerprint: string
  message: string
  method?: string
  path?: string
  status?: number
  requestId?: string
  userId?: number
  occurredAt: string
}

export async function sendPageVisit(routeName: string, path: string, replaySessionId: number) {
  const { data } = await axios.post<Visit>(`${endpoint}/visits`, {
    routeName,
    path,
    replaySessionId
  })
  return data
}

export async function sendButtonClick(eventName: string, visitId: number) {
  const { data } = await axios.post(`${endpoint}/interactions`, { eventName, visitId })
  return data
}

export async function getVisits(
  params: { cursor?: string; limit?: number; search?: string; from?: string; to?: string } = {}
) {
  const { data } = await axios.get<CursorPage<Visit>>(`${endpoint}/visits`, { params })
  return data
}

export async function getVisitAnalytics(params: { from?: string; to?: string } = {}) {
  const { data } = await axios.get<VisitAnalytics>(`${endpoint}/analytics/visits`, { params })
  return data
}

export async function getInteractionAnalytics(
  routeName: string,
  params: { from?: string; to?: string } = {}
) {
  const { data } = await axios.get<InteractionAnalytics>(`${endpoint}/analytics/interactions`, {
    params: { routeName, ...params }
  })
  return { ...data, actions: Array.isArray(data.actions) ? data.actions : [] }
}

export async function getErrorEvents(
  params: { cursor?: string; limit?: number; from?: string; to?: string } = {}
) {
  const { data } = await axios.get<CursorPage<ErrorEvent>>(`${endpoint}/errors`, { params })
  return data
}
